@if (!selectedAttachment.ehrConsultNoteReference && !usePdfKitViewer) {
  <div class="row g-0 align-items-end mb-1">
    <div class="col-6">
      Page {{ activePage }} @if (activePage === selectedAttachment.medicationsPage) {
      <span>(Medications)</span>
    }
  </div>
</div>
}

<div (click)="onDocumentClick($event)">
  @if (!selectedAttachment.ehrConsultNoteReference) {
    @if (!usePdfKitViewer) {
      <app-pdf-file-viewer
        height="86rem"
        [pdfFile]="selectedAttachment"
        [pdfFileType]="pdfFileType"
        [initialPage]="initialPage"
        [hideRotationControls]="hidePdfRotationControls"
        (pageChange)="onPageChange($event)" />
    }
    @if (usePdfKitViewer) {
      <app-pdfkit-file-viewer
        height="86rem"
        [pdfFile]="selectedAttachment"
        [pdfFileType]="pdfFileType"
        (urlChange)="onUrlChange($event)" />
    }
  }

  @if (selectedAttachment.ehrConsultNoteReference) {
    <div>
      <app-ehr-consult-note-reference
        [ehrConsultNoteReference]="selectedAttachment.ehrConsultNoteReference"
        (referenceUpdated)="onEhrConsultNoteReferenceUpdated($event)" />
    </div>
  }
</div>
